module.exports = __webpack_public_path__ + "static/media/04-6WHEELS_CRAN.b5d4e18a.png";